module.exports = require('./helpers/bundle-url').getBundleURL('7wWRQ') + "logo.c51670a8.svg";